import { EditRoomMemberLocks } from "@features/builder/hooks/socketIOHooks"

export const getUniqueMembers = (roomMembers?: Map<string, EditRoomMemberLocks>) => {
  const uniqueMembers = new Map<string, EditRoomMemberLocks>()

  for (const entry of roomMembers?.values() ?? []) {
    const identityKey = (entry.member.email || entry.member.name || entry.member.sid).toLowerCase()
    const existing = uniqueMembers.get(identityKey)

    if (!existing) {
      uniqueMembers.set(identityKey, entry)
      continue
    }

    if (existing.isPlaceholder && !entry.isPlaceholder) {
      uniqueMembers.set(identityKey, entry)
    }
  }

  return uniqueMembers
}
